import { render, staticRenderFns } from "./UnistarsManager.vue?vue&type=template&id=0041c1fc&"
import script from "./UnistarsManager.vue?vue&type=script&lang=js&"
export * from "./UnistarsManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports